import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, ChevronLeft, PenSquare, BookOpenCheck, Headphones } from "lucide-react";

export default function StudentModules() {
  const { subjectId } = useParams();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/modules?subject_id=${subjectId}`).then((r) => setItems(r.data)); }, [subjectId]);
  return (
    <div className="space-y-6" data-testid="student-modules-page">
      <Link to="/student/courses" className="text-sm text-slate-500 hover:text-slate-900 inline-flex items-center gap-1"><ChevronLeft className="w-4 h-4" />Back to Courses</Link>
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600">Subject</div>
        <h1 className="font-display text-3xl font-bold tracking-tight mt-1">Modules</h1>
        <p className="text-slate-600 mt-1">Pick a mode for each module. <span className="font-semibold text-slate-900">Exam Mode</span> tracks your score; <span className="font-semibold text-slate-900">Review Mode</span> is for studying.</p>
      </div>
      <div className="grid grid-cols-1 2xl:grid-cols-3 gap-4">
        {items.length === 0 ? <div className="text-slate-500 col-span-full">No modules yet.</div> :
          items.map((m) => (
            <Card key={m.id} className="p-6 border-slate-200 hover:shadow-md transition-shadow flex flex-col" data-testid={`student-module-${m.id}`}>
              <div className="h-10 w-10 rounded-md bg-blue-50 text-blue-700 grid place-items-center mb-4"><FileText className="w-5 h-5" strokeWidth={1.5} /></div>
              <h3 className="font-display text-lg font-bold break-words">{m.module_title}</h3>
              <p className="text-sm text-slate-600 mt-1 line-clamp-2 flex-1 break-words">{m.description}</p>
              {/* Stack Exam + Review vertically so long labels never overflow
                  on narrow cards (iPad landscape 3-col grid clipped
                  "Review Mode" text on the 2-col button row). */}
              <div className="mt-5 flex flex-col gap-2">
                <Link to={`/student/modules/${m.id}/review`} data-testid={`exam-mode-${m.id}`}>
                  <Button className="w-full bg-[#1E3A8A] hover:bg-[#1E40AF] text-sm h-9">
                    <PenSquare className="w-4 h-4 mr-2 shrink-0" /> Exam Mode
                  </Button>
                </Link>
                <Link to={`/student/modules/${m.id}/review-mode`} data-testid={`review-mode-${m.id}`}>
                  <Button variant="outline" className="w-full border-indigo-300 text-indigo-700 hover:bg-indigo-50 text-sm h-9">
                    <BookOpenCheck className="w-4 h-4 mr-2 shrink-0" /> Review Mode
                  </Button>
                </Link>
                <Link to={`/student/modules/${m.id}/podcast`} data-testid={`podcast-mode-${m.id}`}>
                  <Button variant="outline" className="w-full border-amber-300 text-amber-800 hover:bg-amber-50 text-sm h-9 bg-gradient-to-r from-amber-50 to-orange-50">
                    <Headphones className="w-4 h-4 mr-2 shrink-0" /> Podcast Mode
                  </Button>
                </Link>
              </div>
            </Card>
          ))}
      </div>
    </div>
  );
}
